<app-form-modal
  title="Add New Payment Method"
  [(visible)]="visible"
  formId="newPaymentMethodForm"
  (cancelForm)="onCancel()"
  (visibleChange)="onVisibleChange($event)"
  [submitLabel]="(createPaymentMethodState$ | async)?.isLoading ? 'Adding New Payment Method...' : 'Add Payment Method'"
  [disabled]="(createPaymentMethodState$ | async)?.isLoading"
>
  <div class="-mx-7">
    <div class="px-7">
      <app-message
        *ngIf="(createPaymentMethodState$ | async)?.error"
        severity="error"
        data-cy="error-create-payment-method-api-message"
      >
        {{ (createPaymentMethodState$ | async)?.error?.uiMessage }}
      </app-message>
    </div>

    <form
      [formGroup]="newPaymentMethodForm"
      (ngSubmit)="onSubmit()"
      id="newPaymentMethodForm"
      data-cy="new-payment-method-form"
    >
      <div class="px-7">
        <app-form-field
          [control]="asFormControl(newPaymentMethodForm.get('type'))"
          name="type"
          type="radio"
          [options]="paymentMethodTypeOptions"
          [horizontalLayout]="true"
        ></app-form-field>

        <div *ngIf="newPaymentMethodForm.get('type')?.value === PaymentMethodType.CreditCard || newPaymentMethodForm.get('type')?.value === PaymentMethodType.HealthSavingsAccount">
          <app-form-field
            [control]="asFormControl(newPaymentMethodForm.get('creditCardInfo')?.get('number'))"
            name="number"
            label="Card Number"
            inputMode="numeric"
            [rightImageUrl]="this.processorLogoUrl"
            type="input"
            class="credit-card-form-field"
          ></app-form-field>
          <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('creditCardInfo')?.get('expirationMonth'))"
              name="expirationMonth"
              label="Expiration Month"
              errorLabel="Expiration Date"
              type="dropdown"
              [options]="expirationMonthOptions"
              placeholder="Expiration Month"
            ></app-form-field>
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('creditCardInfo')?.get('expirationYear'))"
              name="expirationYear"
              label="Expiration Year"
              type="dropdown"
              [options]="expirationYearOptions"
              placeholder="Expiration Year"
            ></app-form-field>
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('creditCardInfo')?.get('cvv'))"
              name="cvv"
              label="CVV"
              type="input"
              inputType="text"
              inputMode="numeric"
            ></app-form-field>
          </div>
        </div>
        <div *ngIf="newPaymentMethodForm.get('type')?.value === PaymentMethodType.BankAccount">
          <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
            <app-form-field
              class="col-12 sm:col-6 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('bankAccountInfo')?.get('routingNumber'))"
              name="routingNumber"
              label="Routing Number"
              type="input"
              inputMode="numeric"
              inputMask="999999999"
            ></app-form-field>
            <app-form-field
              class="col-12 sm:col-6 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('bankAccountInfo')?.get('accountNumber'))"
              name="accountNumber"
              label="Account Number"
              type="input"
              inputMode="numeric"
              inputMask="99999999?9999999999"
            ></app-form-field>
          </div>
          <app-form-field
            [control]="asFormControl(newPaymentMethodForm.get('bankAccountInfo')?.get('accountType'))"
            name="accountType"
            label="Account Type"
            type="dropdown"
            [options]="bankAccountOptions"
            placeholder="Select an account type"
          ></app-form-field>
        </div>
        <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(newPaymentMethodForm.get('firstName'))"
            name="firstName"
            label="First Name"
            type="input"
          ></app-form-field>
          <app-form-field
            class="col-12 sm:col-6 sm:py-0 sm:px-1"
            [control]="asFormControl(newPaymentMethodForm.get('lastName'))"
            name="lastName"
            label="Last Name"
            type="input"
          ></app-form-field>
        </div>
        <app-form-field
          *ngIf="((paymentMethods$ | async)?.length || 0) > 0"
          [control]="asFormControl(newPaymentMethodForm.get('isDefault'))"
          name="isDefault"
          label="Make this my default payment method"
          [noMargin]="true"
          type="checkbox-binary"
        ></app-form-field>
      </div>

      <p-divider></p-divider>

      <div class="px-7">
        <h3 class="mt-5">Billing Address</h3>
        <form *ngIf="((paymentMethods$ | async)?.length || 0) > 0" class="mt-4">
          <div class="formgroup-inline mt-2 mb-0 w-full">
            <p-radioButton
              name="newAddressToggle"
              [(ngModel)]="isNewAddress"
              label="Use existing address"
              [value]="false"
              class="field-radiobutton"
              (onClick)="useExistingAddress()"
              ariaLabel="Use existing address"
              data-cy="use-existing-address-radio-option"
            ></p-radioButton>
            <p-radioButton
              name="newAddressToggle"
              [(ngModel)]="isNewAddress"
              label="Add new address"
              [value]="true"
              class="field-radiobutton"
              (onClick)="useNewAddress()"
              ariaLabel="Use existing address"
              data-cy="add-new-address-radio-option"
            ></p-radioButton>
          </div>
        </form>
        <div *ngIf="!isNewAddress">
          <app-form-field
            [control]="asFormControl(newPaymentMethodForm.get('addressPaymentMethodId'))"
            name="addressPaymentMethodId"
            label="Billing Address"
            type="dropdown"
            [options]="addressOptions"
            placeholder="Select a billing address on file"
          ></app-form-field>
        </div>
        <div *ngIf="isNewAddress">
          <app-form-field
            [control]="asFormControl(newPaymentMethodForm.get('addressLine1'))"
            name="addressLine1"
            label="Address 1"
            type="input"
          ></app-form-field>
          <app-form-field
            [control]="asFormControl(newPaymentMethodForm.get('addressLine2'))"
            name="addressLine2"
            label="Address 2"
            type="input"
          ></app-form-field>
          <div class="grid grid-nogutter sm:my-0 sm:-mx-1">
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('addressCity'))"
              name="addressCity"
              label="City"
              type="input"
            ></app-form-field>
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('addressState'))"
              name="addressState"
              label="State"
              type="dropdown"
              [options]="usStateOptions"
              placeholder="Select State"
            ></app-form-field>
            <app-form-field
              class="col-12 sm:col-6 md:col-4 sm:py-0 sm:px-1"
              [control]="asFormControl(newPaymentMethodForm.get('addressZipCode'))"
              name="addressZipCode"
              label="Zip Code"
              type="input"
            ></app-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
</app-form-modal>
